<template>
    <div class="metapose-main-menu">
        <link type="text/css" rel="stylesheet" href="//unpkg.com/bootstrap/dist/css/bootstrap.min.css"/>
        <link type="text/css" rel="stylesheet" href="//unpkg.com/bootstrap-vue@1.5.0/dist/bootstrap-vue.css"/>
        <b-navbar id="metapose-main-navbar" toggleable="md" type="dark" variant="info">
            <b-nav-toggle target="nav_collapse"></b-nav-toggle>
            <b-navbar-brand to="/">Metapose</b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
                <b-nav is-nav-bar class="mr-auto">
<!--                    <b-nav-item-dropdown text="Application">
                        <b-dropdown-item href="#">Health</b-dropdown-item>
                        <b-dropdown-item href="#">Education</b-dropdown-item>
                        <b-dropdown-item href="#">Money</b-dropdown-item>
                    </b-nav-item-dropdown>
-->
                    <b-nav-item to="/About">About</b-nav-item>
                    <b-nav-item to="/Contact">Contact</b-nav-item>
                </b-nav>
                <b-nav is-nav-bar>
                    <b-nav-item to="/account/signin" v-if="isAuthenticated === false">Signin</b-nav-item>
                    <b-nav-item-dropdown v-else :text="longUsername">
                        <b-dropdown-item @click="signout()">Signout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>
<script src="//unpkg.com/bootstrap-vue@1.5.0/dist/bootstrap-vue.js"></script>
<script src="//unpkg.com/babel-polyfill@6.26.0/dist/polyfill.min.js"></script>
<script>
export default
{
    name: 'MetaposeMainMenu',
    data()
    {
        return {
        };
    },
    methods: {
        signout: onSignout
    },
    computed: {
        isAuthenticated()
        {
            return this.$store.state.user.isAuthenticated;
        },
        longUsername()
        {
            return this.$store.state.user.longUsername;
        }
    },
    beforeCreate:   onBeforeCreate,
    beforeUpdate:   onBeforeUpdate,
    updated:        onUpdated
}


////////////////////////////////////////////////////////////////////////////////
//
//
//
function onSignout( event )
{
    var _this = this;
    this.$user.signOut(
            function successCallback()
            {
                _this.$router.push( '/' );
            },
            function failureCallback( error )
            {
            }
        );
}


////////////////////////////////////////////////////////////////////////////////
//
//
//
function onBeforeCreate()
{
    console.log( 'main-menu onBeforeCreate' );
}


////////////////////////////////////////////////////////////////////////////////
//
//
//
function onBeforeUpdate()
{
    console.log( 'main-menu onBeforeUpdate' );
}


////////////////////////////////////////////////////////////////////////////////
//
//
//
function onUpdated()
{
    console.log( 'main-menu onUpdated' );
}
</script>




// WEBPACK FOOTER //
// src/components/main-menu.vue